import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { useLazyQuery } from "@apollo/client";

// Custom.
import Wrapper from "../Content/Wrapper";
import Report from "../Content/Report";
import Row from "../Content/Row";
import Header from "../Content/Header";
import { GET_STATISTICS_AMBASSADOR_CERTIFICATES } from "api";
import { GeneralObject } from "@vocollege/app/dist/global";
import VoLoader from "@vocollege/components/dist/VoLoader";
import Stack from "@mui/material/Stack";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import { getStatisticsData, getStatisticsTotal } from "services/Utils";
import { DownloadExcelButtonProps } from "@vocollege/components/dist/DownloadExcelButton";
import { getExcelData } from "./Utils";

const StatisticsAmbassadorCertificates: React.FC = () => {
  const [parsedData, setParsedData] = useState<GeneralObject[]>([]);
  const [excelData, setExcelData] = useState<DownloadExcelButtonProps | null>(
    null
  );

  // Methods.

  const handleHeaderChange = (params: GeneralObject) => {
    loadQuery({
      variables: {
        from: params.from,
        to: params.to,
        groupBy: params.groupBy,
      },
    });
  };

  // Api.

  const [loadQuery, { data, loading, variables }] = useLazyQuery(
    GET_STATISTICS_AMBASSADOR_CERTIFICATES,
    {
      fetchPolicy: "network-only",
      onCompleted: (loadedData) => {
        setParsedData(
          getStatisticsData(
            loadedData?.certStatisticsAmbassadorCertificates.data
          )
        );
      },
    }
  );

  // Effects.

  useEffect(() => {
    setExcelData(getExcelData(data, parsedData, variables));
  }, [parsedData, data, variables]);

  return (
    <Wrapper
      title={I18n.get.ambassadorCertificate.labels.ambassadorCertificates}
      hideTitleOnPrint
    >
      <Header
        filters={["from", "to", "groupBy"]}
        groupBy={["local", "region"]}
        onChange={handleHeaderChange}
        excel={excelData || undefined}
      />
      {!loading && data && (
        <Box
          sx={{
            mt: 4,
            "@media print": {
              mt: 0,
            },
          }}
        >
          <Report
            title={I18n.get.ambassadorCertificate.label}
            subtitle={I18n.trans(I18n.get.vocertStatistics.perItem, {
              item: I18n.get.group.categories[variables?.groupBy].toLowerCase(),
            })}
            date={data?.certStatisticsAmbassadorCertificates.createdAt}
            interval={`${variables?.from} - ${variables?.to}`}
            summary={
              <Box>
                <Row
                  label={I18n.get.vocertStatistics.total}
                  value={getStatisticsTotal(parsedData)}
                />
              </Box>
            }
          >
            <Stack>
              {parsedData.map((v: GeneralObject, i: number) => (
                <Box key={i}>
                  <Row key={i} label={v.title} value={v.total} />
                </Box>
              ))}
            </Stack>
          </Report>
        </Box>
      )}
      {loading && <VoLoader />}
    </Wrapper>
  );
};

export default StatisticsAmbassadorCertificates;
